export const CATEGORIE_DEFAULT = 'Short LC';

export const LISTE_CATEGORIE_PANNEAU = [
  {
    libelle: 'LC',
    couleur: '#DB19FF',
  },
  {
    libelle: 'LC Tournante',
    couleur: '#4B52FF',
  },
  {
    libelle: 'Réseaux Permanent',
    couleur: '#F5C524',
  },
  {
    libelle: 'Réseaux Semi-Permanent',
    couleur: '#EF7049',
  },
  {
    libelle: 'RESEAU MIXTE',
    couleur: '#F44E3B',
  },
  {
    libelle: 'LC/LTO',
    couleur: '#4BD5FE',
  },
  {
    libelle: 'SMS',
    couleur: '#2DAA4A',
  },
  {
    libelle: 'AT',
    couleur: '#B72121',
  },
  {
    libelle: CATEGORIE_DEFAULT,
    couleur: '#0062b1',
  },
];

export const BUDGET_ANNUEL = 'budgetAnnuel';
export const BUDGET_PRORATA = 'budgetProrata';
